import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsCurveHoldSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 4h1a8 8 0 0 1 8 8v8" stroke="#B5E2FC" strokeWidth={2} />
    <path
      fill="var(--color-typo-primary)"
      d="M9 6H5V2h4zM18 22h-4v-4h4zM18 14h-4v-4h4z"
    />
  </svg>
);
export default IconToolsCurveHoldSizeM;
